export const MODULE_ACCOUNT_TYPE_LABELS = {
  system: '系統',
  platform: '平台',
  client: '客戶'
};

export const MODULE_ACCOUNT_TYPE_BADGE_CLASS = {
  system: 'badge badge-danger',
  platform: 'badge badge-info',
  client: 'badge badge-success'
};

export function getModuleVisibleAccountTypes(module) {
  if (!module) return [];
  if (Array.isArray(module.visibleAccountTypes) && module.visibleAccountTypes.length) {
    return module.visibleAccountTypes;
  }
  if (Array.isArray(module.visible_account_types) && module.visible_account_types.length) {
    return module.visible_account_types;
  }
  const category = module.moduleCategory || module.module_category;
  if (category === 'optional' || category === 'addon') return ['client'];
  if (category === 'platform') return ['system', 'platform'];
  if (category === 'system' || category === 'client') return [category];
  return [];
}

export function isModuleOptional(module) {
  if (!module) return false;
  if (module.isOptional === true || module.is_optional === true) return true;
  const category = module.moduleCategory || module.module_category;
  return category === 'optional' || category === 'addon';
}

export function applyAccountTypeToggle(currentTypes, type, checked) {
  const set = new Set(currentTypes || []);
  if (type === 'client') {
    return checked ? ['client'] : [];
  }
  if (checked) {
    set.delete('client');
    if (type === 'platform') {
      set.add('system');
      set.add('platform');
    } else {
      set.add('system');
    }
  } else if (type === 'platform') {
    set.delete('platform');
  } else {
    set.delete('system');
    set.delete('platform');
  }
  return ['system', 'platform', 'client'].filter((item) => set.has(item));
}

export function moduleMatchesAccountType(module, accountType) {
  if (!accountType) return true;
  return getModuleVisibleAccountTypes(module).includes(accountType);
}

/** 儲存角色模組時只送適用該帳號類型的 ID，避免把歷史不相容模組一併送出 */
export function filterSelectedModuleIdsForAccountType(modules, selectedIds, accountType) {
  const list = Array.isArray(modules) ? modules : [];
  const ids = Array.isArray(selectedIds) ? selectedIds : [];
  if (!accountType) return [...ids];
  const byId = new Map(list.map((module) => [module.id, module]));
  return ids.filter((id) => moduleMatchesAccountType(byId.get(id), accountType));
}
